import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import ProductCard from "@/components/ProductCard";

const filters = [
  { id: "all", label: "All Tees" },
  { id: "graphic", label: "Graphic" },
  { id: "essentials", label: "Essentials" },
];

export default function Shop() {
  const [products, setProducts] = useState([]);
  const [active, setActive] = useState("all");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get(`/products${active !== "all" ? `?category=${active}` : ""}`)
      .then(({ data }) => setProducts(data))
      .finally(() => setLoading(false));
  }, [active]);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12" data-testid="shop-page">
      <h1 className="font-display font-bold text-4xl sm:text-5xl">The Collection</h1>
      <p className="mt-2 font-semibold text-ink/70">Loud tees for people who don't blend in.</p>

      <div className="flex flex-wrap gap-3 mt-8 mb-10">
        {filters.map((f) => (
          <button
            key={f.id}
            onClick={() => setActive(f.id)}
            data-testid={`filter-${f.id}`}
            className={`px-5 py-2.5 rounded-full font-bold border-2 border-ink neo-press ${active === f.id ? "bg-ink text-paper" : "bg-white"}`}
          >
            {f.label}
          </button>
        ))}
      </div>

      {loading ? (
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {[...Array(8)].map((_, i) => <div key={i} className="aspect-[3/4] bg-white neo rounded-2xl animate-pulse" />)}
        </div>
      ) : (
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {products.map((p) => <ProductCard key={p.product_id} product={p} />)}
        </div>
      )}
    </div>
  );
}
